module.exports = __webpack_public_path__ + "img/y-121.d407ea22.png";